import {
    SimplePresentation
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../TheCrypt";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";
import {gsap} from "gsap";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";

export class WinCapPresentation implements SimplePresentation {
    name: string = "WinCapPresentation";
    private _flowStateController: FlowStateController;
    shouldRun(): boolean {
        return TheCrypt.model.brokeTheBank;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;
        const tl: gsap.core.Timeline = gsap.timeline(),
            startTime: number = TheCrypt.model.hasXWaysSymbolThisAvalanche ? 1 : 0,
            shakeDuration:number = 3;
        tl.add(()=>TheCryptSoundManager.playSound("capWinIntro"), startTime);
        for (let i: number = 0; i < 6; i++) {
            TheCrypt.realArea.allReels[i].reelView.getAllSymbols().forEach((sym: TheCryptSymbol) => {
                tl.add(sym.getShakeAnimation(shakeDuration, true), startTime);
            });
        }
        tl.add(TheCrypt.winCapScreen.show(() => this.complete()));
    }

    public complete():void {
        this._flowStateController.finish();
        TheCrypt.keypadPlugin.setZeroBetSpinCounter(-1);
        TheCrypt.keypadPlugin.show();
        TheCrypt.collectors.reset();
        TheCrypt.setMode(TheCrypt.model.data.nextMode);
    }
}